import React from "react";

export default class BaseApp extends React.Component {

    componentDidMount() {
        this.props.fetchData(`${this.props.base_url}/cur/${this.props.kp}/`);
        this.props.wsConnect();
    }

}



// WEBPACK FOOTER //
// ./src/lib/core/BaseApp/index.jsx